export default __webpack_public_path__ + "geburtstag-teaser-04.f65d25bb7cad689a3a5fe278994239c2.png";